export default __webpack_public_path__ + "static/media/Tarun.bad0b92f.JPG";